import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categoryArticles } from '@/mocks/articles';
import { categories } from '@/mocks/homeData';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  const articles = category
    ? categoryArticles.filter((a) => a.categorySlug === slug)
    : categoryArticles;

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-20 pb-10">
          <div className="w-full px-4 md:px-6 text-center py-20">
            <p className="text-foreground-500 text-lg">分类未找到</p>
            <Link to="/" className="text-primary-500 hover:underline mt-4 inline-block">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const pageTitle = `${category.name} - 每日黑料`;
  const pageDescription = `${category.description}，每日黑料为您实时更新${category.name}相关的最新爆料资讯。`;

  return (
    <>
      <Navbar />
      <main>
        <section className="pt-24 pb-12 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
            <Breadcrumb />

            <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-3">
              {category.name}
            </h1>
            <p className="text-base md:text-lg text-foreground-600 mb-8">
              {category.description}
            </p>

            <div className="flex items-center gap-3 mb-8">
              <Link
                to="/"
                className="whitespace-nowrap px-4 py-2 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors"
              >
                <i className="ri-arrow-left-line mr-1"></i>返回首页
              </Link>
            </div>

            <div className="relative w-full h-[300px] md:h-[400px] rounded-2xl overflow-hidden mb-10">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20abstract%20artistic%20composition%20with%20warm%20beige%20base%20and%20deep%20crimson%20accents%20flowing%20ink%20texture%20mysterious%20atmosphere%20editorial%20magazine%20style%20category%20banner%20wide%20panoramic%20format%20subtle%20dramatic%20lighting&width=1400&height=600&seq=category-hero-bg&orientation=landscape"
                alt={category.name}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            </div>
          </div>
        </section>

        <section className="py-12 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {articles.map((article, index) => (
                <Link
                  key={article.slug}
                  to="/category/all"
                  className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    {index === 0 && (
                      <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full">
                        最新
                      </span>
                    )}
                  </div>
                  <div className="p-4">
                    <span className="inline-block text-xs text-primary-600 bg-primary-100/70 px-2 py-0.5 rounded-full mb-2">
                      {article.category}
                    </span>
                    <h3 className="text-base font-heading font-bold text-foreground-950 mb-3 line-clamp-2 group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 mb-3 line-clamp-2 leading-relaxed">
                      {article.summary}
                    </p>
                    <div className="flex items-center gap-4 text-xs text-foreground-500">
                      <span><i className="ri-eye-line mr-1"></i>{(article.views / 10000).toFixed(1)}万</span>
                      <span><i className="ri-message-2-line mr-1"></i>{article.comments}</span>
                      <span><i className="ri-calendar-line mr-1"></i>{article.date}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}